import React from 'react';

import SetboxTemplate from "./SetboxTemplate";

const SetboxMilky = () => {

    const data = {
        className: "setbox milky",
        title: `COCO SET BOX\nMILKY & CARAMEL COCO`,
        item01: "- GLAM EYE SHADOW", 
        item02: "- WONDER LIP TINT", 
        price: "3,300 (tax in)", 
        url: "https://uchoobeauty.com/products/set_coco"
    }

    return (
        <SetboxTemplate {...data}/>
    )
}

export default SetboxMilky